import { ApiService } from './api';
import { StatsResponse } from '@/models/common';
import { ApiResponse } from '@/models/common';
import { ApiEndpoints } from '@/models/endpoints';

/**
 * ReportsService
 * 
 * Service for fetching reports and statistics data
 */
export class ReportsService {
  // Get statistics data
  static async getStats(): Promise<ApiResponse<StatsResponse>> {
    try {
      const response = await ApiService.get<StatsResponse>(ApiEndpoints.REPORTS_STATS);
      console.log('ReportsService.getStats response:', response);
      return response;
    } catch (error: any) {
      console.error('ReportsService.getStats error:', error);
      throw error;
    }
  }
}

